// A drag is "text-area-able" — it folds into the cell's native text area
// (transform on empty, add on non-empty) — iff it is a plain RichText element.
// The reliable marker (catalog audit) is a non-empty `placeholder`: the 5 plain
// text elements (Headline/Subtitle/Paragraph/Bulleted/Numbered) have one; every
// special RichText variant (Link/Highlight/Animated/List) and every non-text
// element does not. `textStyle` is null catalog-wide, so it is NOT used.

interface TextLikeSettings {
  name?: string;
  placeholder?: string;
}

export const isTextAreaElement = (
  settings: TextLikeSettings | undefined,
): boolean => settings?.name === "RichText" && !!settings.placeholder?.trim();
